// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"question_wrapper__2NSUt"};